import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import { BottomNav } from "@/components/BottomNav";
import { ExpiryCountdown } from "@/components/ExpiryCountdown";
import Login from "@/screens/Login";
import HomeScreen from "@/screens/Home";
import Search from "@/screens/Search";
import QRGrid from "@/screens/QRGrid";
import QuizSetup from "@/screens/QuizSetup";
import QuizPlay from "@/screens/QuizPlay";
import Results from "@/screens/Results";
import Profile from "@/screens/Profile";
import Offers from "@/screens/Offers";
import GroupDetail from "@/screens/GroupDetail";
import AdminLogin from "@/screens/AdminLogin";
import AdminDashboard from "@/screens/AdminDashboard";
import VenueProfile from "@/screens/VenueProfile";

const NAV_ROUTES = ["/", "/search", "/setup", "/profile"];

function Shell() {
  const { profile } = useApp();
  const location = useLocation();
  const gate = (el) => (profile ? el : <Navigate to="/login" replace />);
  const showNav = !!profile && NAV_ROUTES.includes(location.pathname);
  const isPlayerArea = !!profile && !location.pathname.startsWith("/admin") && !location.pathname.startsWith("/venue") && location.pathname !== "/login" && location.pathname !== "/quiz";

  return (
    <div className="max-w-md mx-auto min-h-screen relative overflow-x-hidden bg-slate-950">
      <div className={showNav ? "pb-28" : ""}>
        <Routes>
          {/* Admin + public venue routes (no player gate) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/venue/:id" element={<VenueProfile />} />

          {/* Player routes */}
          <Route path="/login" element={profile ? <Navigate to="/" replace /> : <Login />} />
          <Route path="/" element={gate(<HomeScreen />)} />
          <Route path="/search" element={gate(<Search />)} />
          <Route path="/qr" element={gate(<QRGrid />)} />
          <Route path="/setup" element={gate(<QuizSetup />)} />
          <Route path="/quiz" element={gate(<QuizPlay />)} />
          <Route path="/results" element={gate(<Results />)} />
          <Route path="/profile" element={gate(<Profile />)} />
          <Route path="/offers" element={gate(<Offers />)} />
          <Route path="/group/:id" element={gate(<GroupDetail />)} />
          <Route path="*" element={<Navigate to={profile ? "/" : "/login"} replace />} />
        </Routes>
      </div>
      {isPlayerArea && <ExpiryCountdown />}
      {showNav && <BottomNav />}
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AppProvider>
    </div>
  );
}

export default App;
